<script lang="ts" setup>
import LiteYoutubeEmbed from "~/components/articles/blocks/LiteYoutubeEmbed.vue";

defineProps({
    url: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <div class="mx-auto my-5 max-w-4xl overflow-hidden rounded-lg border-4 border-gray-300">
        <LiteYoutubeEmbed :url="url" />
    </div>
</template>

<style scoped>
:deep(#container iframe) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
